import { GET_TASK_TREND, GET_TASK_TREND_SUCCESS, GET_TASK_TREND_ERROR } from './actionTypes';

export const getTaskTrend = (user) => {
  return {
    type: GET_TASK_TREND,
    payload: { user },
  };
};

export const getTaskTrendSuccess = (trend, message) => {
  return {
    type: GET_TASK_TREND_SUCCESS,
    payload: { trend, message },
  };
};

export const getTaskTrendError = (msg) => {
  return {
    type: GET_TASK_TREND_ERROR,
    payload: msg,
  };
};
